import { render, staticRenderFns } from "./TrainingVideoModalTrigger.vue?vue&type=template&id=20337395&"
import script from "./TrainingVideoModalTrigger.vue?vue&type=script&lang=js&"
export * from "./TrainingVideoModalTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports